<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Frequently Asked Questions
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="row">
          <div class="col">
            <p>
              Use the frequently asked questions page to find answers to your common questions.
            </p>

            <div
              v-if="error"
              class="alert alert-danger"
              role="alert"
              v-text="error"
            />

            <div
              v-else
              id="faqAccordion"
              ref="accordion"
              class="accordion"
            >
              <div
                v-for="(question, index) in questions"
                :key="question.id"
                class="card"
              >
                <div
                  :id="`faq-${question.id}`"
                  class="card-header"
                >
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left text-dark"
                      type="button"
                      data-toggle="collapse"
                      :data-target="`#faq-question-${question.id}`"
                      aria-expanded="true"
                      :aria-controls="`faq-question-${question.id}`"
                      v-text="`${index + 1}. ${question.title}`"
                    />
                  </h2>
                </div>

                <div
                  :id="`faq-question-${question.id}`"
                  class="collapse"
                  :class="{ 'show': index === 0 }"
                  :aria-labelledby="`faq-${question.id}`"
                  data-parent="#faqAccordion"
                >
                  <div
                    class="card-body"
                    v-html="question.body"
                  />
                </div>
              </div>

              <p class="mt-4">
                Still can't find what you're looking for?
                <router-link to="/contact">
                  <u>Contact us</u>
                </router-link>!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";

export default {
  name: "FrequentlyAskedQuestions",
  data: () => ({
    error: '',
    questions: [],
  }),
  mounted() {
    this.loadQuestions();

    $(this.$refs.accordion).on('shown.bs.collapse', (e) => {
      const y = this.$refs.accordion.querySelector('.collapse.show').previousElementSibling.getBoundingClientRect().top
                + window.scrollY
                - document.getElementById('mainNav').offsetHeight
                - 10 /* Some padding */;

      window.scrollTo({top: y, behavior: 'smooth'});
    });
  },
  methods: {
    loadQuestions() {
      try {
        this.error = '';

        axios.get('/api/faq').then((response) => {
          if (response && response.status === 200 && response.data) {
            this.questions = response.data;

            return;
          }

          throw response;
        }).catch(e => this.error = '' + e);
      } catch (e) {
        this.error = '' + e;
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style scoped>

</style>